import { StyleSheet } from "react-native"
import { baseColors, baseFontFamily, basePadding } from "@Constants/baseStyles"
import { RFValue } from "react-native-responsive-fontsize"

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: baseColors.white
    },
    content: {
        paddingVertical: basePadding.paddingVertical
    },
    item: {
        backgroundColor: baseColors.green.light,
        borderRadius: 10,
        marginBottom: 18
    },
    marginBottom: { marginBottom: RFValue(12) }
})

export default styles
